<template>
  <v-form v-model="formValid">
    <v-container v-if="loading.type !== 'getCampaign' && !localLoading">
      <!-- App -->
      <v-row
        v-if="(!campaign.IsTemplate || isNew) && !isTemplate"
        v-show="showApplicationSelect"
      >
        <v-col cols="12" sm="2">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="secondary" v-bind="attrs" v-on="on">
                {{ getAppNameByAppId(campaign.AppId) }}
              </v-btn>
            </template>
            <v-list v-if="availableApplications.length">
              <v-list-item
                v-for="(item, index) in availableApplications"
                :key="index"
                selected
                @click="appId = item.ID"
              >
                <v-list-item-title>{{ item.ShortName }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row v-if="campaign.ID > 0 && !campaign.IsTemplate && !isNew">
        <v-col class="d-flex align-center">
          <v-btn
            v-if="
              campaign.ID > 0 && (!campaign.IsTemplate || isNew) && !isTemplate
            "
            color="success"
            outlined
            @click="promoCodesDialog = true"
          >
            <v-icon small>mdi-cog</v-icon>
            {{ $vuetify.lang.t('$vuetify.GENERATE_ONE_TIME_PROMO_CODES') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="d-flex align-center">
        <!-- Region -->
        <v-col
          v-show="
            showUserRegionsSelect &&
              (!campaign.IsTemplate || isNew) &&
              !isTemplate
          "
          cols="12"
          sm="2"
        >
          <v-select
            v-model="region"
            :items="userRegions"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.REGION')"
            outlined
            hide-details
            :loading="loading.state && loading.type === 'getUserRegions'"
            :rules="!campaign.IsTemplate ? regionRules : true"
            required
            :disabled="currentCampaignId > 0"
          ></v-select>
        </v-col>
        <!-- Name -->
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="name"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.NAME')"
            :placeholder="$vuetify.lang.t('$vuetify.EDIT_FLEETS.NAME')"
            outlined
            hide-details
            :rules="nameRules"
            required
          ></v-text-field>
        </v-col>
        <!-- Valid From -->
        <v-col
          v-show="(!campaign.IsTemplate || isNew) && !isTemplate"
          cols="12"
          sm="3"
        >
          <v-menu
            v-model="validFromPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatDate(getDateInTimeZone(validFrom, timeZone))"
                :label="$vuetify.lang.t('$vuetify.VALID_FROM')"
                :placeholder="$vuetify.lang.t('$vuetify.VALID_FROM')"
                append-icon="mdi-calendar"
                readonly
                outlined
                hide-details
                clearable
                v-bind="attrs"
                @click:clear="validFrom = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :value="formatDateISO(getDateInTimeZone(validFrom, timeZone))"
              @change="validFrom = getDateWithTimeZone($event, timeZone)"
              @input="validFromPicker = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <!-- Valid To -->
        <v-col
          v-show="(!campaign.IsTemplate || isNew) && !isTemplate"
          cols="12"
          sm="3"
        >
          <v-menu
            v-model="validToPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatDate(getDateInTimeZone(validTo, timeZone))"
                :label="$vuetify.lang.t('$vuetify.VALID_TO')"
                :placeholder="$vuetify.lang.t('$vuetify.VALID_TO')"
                append-icon="mdi-calendar"
                readonly
                outlined
                hide-details
                clearable
                v-bind="attrs"
                @click:clear="validTo = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :value="formatDateISO(getDateInTimeZone(validTo, timeZone))"
              @change="validTo = getDateWithTimeZone($event, timeZone)"
              @input="validToPicker = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <!-- Type -->
        <v-col cols="12" sm="2">
          <!-- <v-menu offset-y :disabled="currentFleetId > 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="secondary" v-bind="attrs" v-on="on">
                {{ type }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in fleetTypes"
                :key="index"
                selected
                @click="type = item"
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
          <v-select
            v-model="type"
            :items="discountTypes"
            :disabled="approvedOrPendingCount > 0"
            :label="$vuetify.lang.t('$vuetify.TYPE')"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col
          v-if="campaign.Type != 'PREPAID_CREDIT'"
          cols="12"
          class="d-flex align-center row"
        >
          <v-col cols="3" class="d-flex align-center">
            <v-checkbox
              v-model="startSessionWithLPR"
              :label="
                $vuetify.lang.t(
                  '$vuetify.EDIT_WHITELISTS.START_SESSIONS_WITH_LPR'
                )
              "
              hide-details
              class="ma-0"
            ></v-checkbox>
            <v-tooltip bottom class="ml-2">
              <template #activator="data">
                <v-icon small v-on="data.on">
                  mdi-help
                </v-icon>
              </template>
              <span>
                {{
                  $vuetify.lang.t(
                    '$vuetify.EDIT_WHITELISTS.START_SESSIONS_WITH_LPR_DESCRIPTION'
                  )
                }}
              </span>
            </v-tooltip>
          </v-col>
          <v-row v-if="campaign.Type !== 'PREPAID_CREDIT'">
            <!-- New clients only -->
            <v-col cols="4">
              <v-checkbox
                v-model="forNewClientsOnly"
                :label="$vuetify.lang.t('$vuetify.NEW_CLIENTS_ONLY')"
                hide-details
                class="ma-0"
              ></v-checkbox>
            </v-col>
            <!-- New clients only -->
            <v-col cols="4">
              <v-checkbox
                v-model="oneTimeDiscount"
                :label="$vuetify.lang.t('$vuetify.ONE_TIME_DISCOUNT')"
                hide-details
                class="ma-0"
              ></v-checkbox>
            </v-col>
            <!-- New clients only -->
            <v-col cols="4">
              <v-checkbox
                v-model="paymentMethodRequired"
                :label="$vuetify.lang.t('$vuetify.PAYMENT_METHOD_REQUIRED')"
                hide-details
                class="ma-0"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
        <!-- Valid in -->
        <v-row
          v-if="
            type !== 'PREPAID_CREDIT' &&
              (!campaign.IsTemplate || isNew) &&
              !isTemplate
          "
          class="d-flex align-center col-12 py-0 pr-0"
        >
          <v-col cols="12" sm="12" md="3">
            <!-- <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" v-on="on">
                  {{ campaign.ValidInType }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="validInType = 'PLACES'">
                  <v-list-item-title>PLACES</v-list-item-title>
                </v-list-item>
                <v-list-item @click="validInType = 'ZONES'">
                  <v-list-item-title>ZONES</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
            <v-select
              v-model="validInType"
              :items="['PLACES', 'ZONES']"
              :label="$vuetify.lang.t('$vuetify.WHITELISTS.VALID_IN')"
              outlined
              hide-details
              required
            >
              <template v-slot:selection="{ item }">
                {{ $vuetify.lang.t(`$vuetify.IN_${item}`) }}
              </template>
              <template v-slot:item="{ item }">
                {{ $vuetify.lang.t(`$vuetify.IN_${item}`) }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="9" class="pr-0">
            <v-autocomplete
              v-if="campaign.ValidInType === 'PLACES'"
              :key="'Id'"
              v-model="places"
              :items="userPlaces"
              :rules="placeRules"
              item-text="AddressText"
              multiple
              hide-details
              return-object
              :menu-props="{ bottom: true, offsetY: true }"
              clearable
              outlined
              label="Select place(s)"
              prepend-inner-icon="mdi-map-marker"
              :loading="loading.state && loading.type === 'getUserPlaces'"
              @focus="getUserPlaces({ region: region })"
            />
            <v-autocomplete
              v-if="campaign.ValidInType === 'ZONES'"
              v-model="zones"
              :items="userZones"
              multiple
              hide-details
              :menu-props="{
                bottom: true,
                offsetY: true
              }"
              clearable
              outlined
              label="Select zone(s)"
              :loading="loading.state && loading.type === 'getUserZones'"
              @focus="getUserZones({ region })"
            />
          </v-col>
        </v-row>
        <!-- MaxNumberOfRegistrants -->
        <v-col v-show="(!campaign.IsTemplate || isNew) && !isTemplate" cols="3">
          <v-text-field
            v-model.number="maxNumberOfRegistrants"
            :label="'Max number of registrants'"
            :placeholder="'Max number of registrants'"
            outlined
            hide-details
            append-icon="mdi-account"
            type="number"
          ></v-text-field>
        </v-col>
        <!-- Discount credit -->
        <v-col cols="3">
          <v-text-field
            v-if="campaign.Type === 'DISCOUNT_CREDIT'"
            v-model="discountCredit"
            :label="'Discount credit'"
            :placeholder="'Discount credit'"
            outlined
            hide-details
            type="number"
            :suffix="campaign.DiscountCreditCurrency"
          />
          <v-text-field
            v-if="campaign.Type === 'PREPAID_CREDIT'"
            v-model="discountCredit"
            :label="'Peapaid credit'"
            :placeholder="'Prepaid credit'"
            outlined
            hide-details
            type="number"
            :suffix="campaign.DiscountCreditCurrency"
          />
          <v-text-field
            v-if="campaign.Type === 'DISCOUNT_PERCENT'"
            v-model="discountPercent"
            :label="'Discount percent'"
            :placeholder="'Discount percent'"
            outlined
            hide-details
            type="number"
            suffix="%"
          />
        </v-col>
        <!-- RegistrationOpenUntil -->
        <v-col
          v-show="(!campaign.IsTemplate || isNew) && !isTemplate"
          cols="12"
          sm="3"
        >
          <v-menu
            v-model="registrationOpenUntilPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="
                  formatDate(getDateInTimeZone(registrationOpenUntil, timeZone))
                "
                :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_OPEN_TIL')"
                :placeholder="
                  $vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_OPEN_TIL')
                "
                append-icon="mdi-calendar"
                readonly
                outlined
                hide-details
                clearable
                v-bind="attrs"
                @click:clear="registrationOpenUntil = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :value="
                formatDateISO(
                  getDateInTimeZone(registrationOpenUntil, timeZone)
                )
              "
              @change="
                registrationOpenUntil = getDateWithTimeZone($event, timeZone)
              "
              @input="registrationOpenUntilPicker = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <!-- App Registration Code -->
        <v-col
          v-show="(!campaign.IsTemplate || isNew) && !isTemplate"
          cols="12"
          sm="3"
        >
          <v-text-field
            v-model="campaignCode"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_CODE_APP')"
            :placeholder="$vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_CODE_APP')"
            required
            outlined
            hide-details
            append-icon="mdi-ticket-percent"
          ></v-text-field>
        </v-col>
        <!-- Description for app -->
        <v-col
          v-if="type !== 'PREPAID_CREDIT'"
          cols="12"
          :sm="(!campaign.IsTemplate || isNew) && !isTemplate ? '6' : '12'"
        >
          <v-textarea
            v-model="appInfoText"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.DESC_FOR_APP')"
            :placeholder="$vuetify.lang.t('$vuetify.EDIT_FLEETS.DESC_FOR_APP')"
            outlined
            hide-details
            height="100"
          >
          </v-textarea>
        </v-col>
        <!-- Description -->
        <v-col cols="12" :sm="type === 'PREPAID_CREDIT' ? '12' : '6'">
          <v-textarea
            v-model="description"
            :label="$vuetify.lang.t('$vuetify.DESCRIPTION')"
            :placeholder="$vuetify.lang.t('$vuetify.DESCRIPTION')"
            outlined
            hide-details
            height="100"
          ></v-textarea>
        </v-col>
        <!-- Email body after successful registration -->
        <v-col cols="12" sm="6">
          <v-textarea
            v-model="approvalMessage"
            :label="
              $vuetify.lang.t(
                '$vuetify.EDIT_FLEETS.EMAIL_BODY_AFTER_REGISTRATION'
              )
            "
            :placeholder="
              $vuetify.lang.t(
                '$vuetify.EDIT_FLEETS.EMAIL_BODY_AFTER_REGISTRATION'
              )
            "
            outlined
            hide-details
            height="100"
          ></v-textarea>
        </v-col>
        <!-- Registration request received message -->
        <v-col v-if="!autoApprove" cols="12" sm="6">
          <v-textarea
            v-model="registrationRequestReceivedMessage"
            :label="$vuetify.lang.t('$vuetify.EMAIL_REQ_INFO')"
            :placeholder="$vuetify.lang.t('$vuetify.EMAIL_REQ_INFO')"
            outlined
            hide-details
            height="100"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row v-show="(!campaign.IsTemplate || isNew) && !isTemplate">
        <!-- Notification Emails -->
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="notificationEmails"
            :label="
              $vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_NOTIFICATION_EMAIL')
            "
            :placeholder="
              $vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_NOTIFICATION_EMAIL')
            "
            required
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-show="(!campaign.IsTemplate || isNew) && !isTemplate">
        <v-col cols="12" sm="5">
          <v-checkbox
            v-model="autoApprove"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.AUTO_APPROVE')"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
      <div
        v-show="campaign.ID > 0 && !campaign.IsTemplate && !isNew"
        class="d-flex align-center"
      >
        <v-checkbox
          v-show="campaign.ID > 0 && !campaign.IsTemplate && !isNew"
          v-model="isPublicRegistrationLinkEnabled"
          :label="$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.PUBLIC_REG_LINK')"
          hide-details
          class="ma-0"
        >
          <template v-slot:label>
            <span class="d-flex align-center">
              {{
                isPublicRegistrationLinkEnabled
                  ? ''
                  : $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.PUBLIC_REG_LINK')
              }}
            </span>
          </template>
        </v-checkbox>
        <a
          style="color: #007CAD;"
          :href="
            `${appUrl}/public/?campaign=${campaign.PublicRegistrationLinkUuid}`
          "
        >
          {{
            isPublicRegistrationLinkEnabled
              ? `${appUrl}/public/?campaign=${campaign.PublicRegistrationLinkUuid}`
              : ''
          }}
        </a>
        <!-- TODO:: Uncomment if PublicLinkSettingsDialog is ready -->
        <v-btn
          v-if="isPublicRegistrationLinkEnabled"
          color="secondary lighten-2"
          class="ml-1"
          icon
          small
          @click="publicLinkSettingsDialog = true"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </div>
      <!-- Icon -->
      <v-row>
        <v-col
          v-if="isGlobalAdmin && campaign.Type != 'PREPAID_CREDIT'"
          cols="3"
        >
          <v-autocomplete
            :key="'Id'"
            v-model="appIconId"
            :items="appIcons"
            item-text="Code"
            item-value="Id"
            hide-details
            return-object
            :menu-props="{ bottom: true, offsetY: true }"
            clearable
            outlined
            :label="$vuetify.lang.t('$vuetify.ICON_FOR_APP')"
            :loading="loading.state && loading.type === 'getAppIcons'"
            dense
          >
            <template v-slot:item="data">
              <v-list-item-avatar size="28">
                <img :src="data.item.Url" style="object-fit: contain;" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.Code }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:selection="data">
              <div class="d-flex align-center">
                <v-list-item-avatar size="24">
                  <img :src="data.item.Url" style="object-fit: contain;" />
                </v-list-item-avatar>
                <v-list-item-title>{{ data.item.Code }}</v-list-item-title>
              </div>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-checkbox
        v-show="campaign.ID > 0 && !campaign.IsTemplate && !isNew"
        v-model="activateExtraDiscountCampaign"
        :label="$vuetify.lang.t('$vuetify.ACTIVATE_NEW_CAMPAIGN')"
        hide-details
        class="ma-0"
      ></v-checkbox>
      <v-col v-show="activateExtraDiscountCampaign" cols="6">
        <v-row>
          <v-text-field
            v-model.number="extraDiscountCampaignActivationDelayInDays"
            :prefix="$vuetify.lang.t('$vuetify.AFTER')"
            :suffix="$vuetify.lang.t('$vuetify.DAYS')"
            class="col-12"
            type="number"
          ></v-text-field>
          <v-select
            v-model="extraDiscountCampaignId"
            :prefix="$vuetify.lang.t('$vuetify.ACTIVATE')"
            :items="campaigns"
            :item-value="'Id'"
            :item-text="'Name'"
            :label="$vuetify.lang.t('$vuetify.SELECT_CAMPAIGN')"
            class="col-12"
            @click="getAllCampaigns()"
          ></v-select>
          <v-text-field
            v-model.number="extraDiscountCampaignNumberOfDaysValid"
            :prefix="$vuetify.lang.t('$vuetify.WHICH_WILL_BE_VALID_FOR')"
            :suffix="$vuetify.lang.t('$vuetify.DAYS')"
            class="col-12"
            type="number"
          ></v-text-field>
        </v-row>
        <h4>
          Thank you note and info about new campaign
        </h4>
        <v-select
          v-model="selectedLanguage"
          :items="languages"
          :label="$vuetify.lang.t('$vuetify.HEADER.LANGUAGE')"
          @input="selectedLanguageChanged()"
        ></v-select>
        <v-textarea
          :value="currentTranslationText()"
          outlined
          hide-details
          height="100"
          @change="textChanged($event)"
        >
        </v-textarea>
      </v-col>
    </v-container>
    <v-toolbar v-else class="elevation-0">
      <v-spacer></v-spacer>
      <v-progress-circular
        indeterminate
        color="secondary"
      ></v-progress-circular>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-toolbar
      v-if="
        (loading.state && loading.type === 'getCampaign') ||
          (loading.type === '' && !campaign)
      "
      class="elevation-0"
    >
      <v-spacer></v-spacer>
      <v-progress-circular
        indeterminate
        color="secondary"
      ></v-progress-circular>
      <v-spacer></v-spacer>
    </v-toolbar>
    <promo-codes-dialog
      :visible="promoCodesDialog"
      @close="promoCodesDialog = false"
    />
    <public-link-settings-dialog
      :uuid="campaign.PublicRegistrationLinkUuid"
      :visible="publicLinkSettingsDialog"
      @close="publicLinkSettingsDialog = false"
    />
  </v-form>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import formatDate from '@/mixins/formatDate'
import Campaign from '@/models/campaign'
import PromoCodesDialog from '@/components/PromoCodesDialog'
import PublicLinkSettingsDialog from '@/components/PublicLinkSettingsDialog'

export default {
  name: 'CampaignForm',
  components: {
    PromoCodesDialog,
    PublicLinkSettingsDialog
  },
  mixins: [formatDate],
  props: {
    campaignId: String
  },
  data() {
    return {
      formValid: false,
      regionRules: [v => v.length >= 2 || 'Regioon on nõutud'],
      nameRules: [v => v.length >= 2 || 'Nimetus on nõutud'],
      // eslint-disable-next-line no-unused-vars
      placeRules: [v => v.length > 1 || 'Asukoht on nõutud'],
      showApplicationSelect: false,
      showUserRegionsSelect: false,
      registrationOpenUntilPicker: false,
      validFromPicker: false,
      validToPicker: false,
      owners: [],
      localLoading: true,
      discountTypes: ['DISCOUNT_PERCENT', 'DISCOUNT_CREDIT'],
      promoCodesDialog: false,
      approvedOrPendingCount: 0,
      appUrl: process.env.VUE_APP_URL,
      publicLinkSettingsDialog: false
    }
  },
  computed: {
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    ...mapGetters('app', ['loading', 'availableApplications', 'appIcons']),
    ...mapGetters('campaigns', [
      'campaigns',
      'campaign',
      'currentCampaignId',
      'isNew',
      'isTemplate',
      'registrants',
      'languages',
      'translations'
    ]),
    ...mapGetters('users', ['userRegions', 'userPlaces', 'userZones', 'users']),
    region: {
      get() {
        return this.campaign.Region
      },
      set(value) {
        this.setCampaignValue({
          key: 'Region',
          value
        })
      }
    },
    type: {
      get() {
        return this.campaign.Type
      },
      set(value) {
        this.setCampaignValue({
          key: 'Type',
          value
        })
      }
    },
    name: {
      get() {
        return this.campaign.Name
      },
      set(value) {
        this.setCampaignValue({
          key: 'Name',
          value
        })
      }
    },
    appId: {
      get() {
        return this.campaign.AppID
      },
      set(value) {
        this.setCampaignValue({
          key: 'AppId',
          value
        })
      }
    },
    validInType: {
      get() {
        return this.campaign.ValidInType
      },
      set(value) {
        this.setCampaignValue({
          key: 'ValidInType',
          value
        })
      }
    },
    places: {
      get() {
        return this.campaign.Places
      },
      set(value) {
        this.setCampaignValue({
          key: 'Places',
          value
        })
      }
    },
    zones: {
      get() {
        return this.campaign.Zones
      },
      set(value) {
        this.setCampaignValue({
          key: 'Zones',
          value
        })
      }
    },
    validFrom: {
      get() {
        return this.campaign.ValidFrom
      },
      set(value) {
        this.setCampaignValue({
          key: 'ValidFrom',
          value
        })
      }
    },
    validTo: {
      get() {
        return this.campaign.ValidTo
      },
      set(value) {
        this.setCampaignValue({
          key: 'ValidTo',
          value
        })
      }
    },
    timeZone: {
      get() {
        return this.campaign.TimeZone
      },
      set(value) {
        this.setCampaignValue({
          key: 'TimeZone',
          value
        })
      }
    },
    registrationOpenUntil: {
      get() {
        return this.campaign.RegistrationOpenUntil
      },
      set(value) {
        this.setCampaignValue({
          key: 'RegistrationOpenUntil',
          value
        })
      }
    },
    campaignCode: {
      get() {
        return this.campaign.CampaignCode
      },
      set(value) {
        this.setCampaignValue({
          key: 'CampaignCode',
          value
        })
      }
    },
    notificationEmails: {
      get() {
        return this.campaign.NotificationEmails
      },
      set(value) {
        this.setCampaignValue({
          key: 'NotificationEmails',
          value
        })
      }
    },
    description: {
      get() {
        return this.campaign.Description
      },
      set(value) {
        this.setCampaignValue({
          key: 'Description',
          value
        })
      }
    },
    appInfoText: {
      get() {
        return this.campaign.AppInfoText
      },
      set(value) {
        this.setCampaignValue({
          key: 'AppInfoText',
          value
        })
      }
    },
    registrationRequestReceivedMessage: {
      get() {
        return this.campaign.RegistrationRequestReceivedMessage
          ? this.campaign.RegistrationRequestReceivedMessage
          : 'Your registration request has been received. You will receive a confirmation email when your registration is confirmed.'
      },
      set(value) {
        this.setCampaignValue({
          key: 'RegistrationRequestReceivedMessage',
          value
        })
      }
    },
    approvalMessage: {
      get() {
        return this.campaign.ApprovalMessage
      },
      set(value) {
        this.setCampaignValue({
          key: 'ApprovalMessage',
          value
        })
      }
    },
    autoApprove: {
      get() {
        return this.campaign.AutoApprove
      },
      set(value) {
        this.setCampaignValue({
          key: 'AutoApprove',
          value
        })
      }
    },
    startSessionWithLPR: {
      get() {
        return this.campaign.StartSessionsWithLPR
      },
      set(value) {
        this.setCampaignValue({
          key: 'StartSessionsWithLPR',
          value
        })
      }
    },
    maxNumberOfRegistrants: {
      get() {
        return this.campaign.MaxNumberOfRegistrants
      },
      set(value) {
        this.setCampaignValue({
          key: 'MaxNumberOfRegistrants',
          value
        })
      }
    },
    discountPercent: {
      get() {
        return this.campaign.DiscountPercent
      },
      set(value) {
        this.setCampaignValue({
          key: 'DiscountPercent',
          value: Number(value)
        })
      }
    },
    discountCredit: {
      get() {
        return this.campaign.DiscountCreditInCents / 100
      },
      set(value) {
        this.setCampaignValue({
          key: 'DiscountCreditInCents',
          value: value * 100
        })
      }
    },
    forNewClientsOnly: {
      get() {
        return this.campaign.ForNewClientsOnly
      },
      set(value) {
        this.setCampaignValue({
          key: 'ForNewClientsOnly',
          value
        })
      }
    },
    oneTimeDiscount: {
      get() {
        return this.campaign.OneTimeDiscount
      },
      set(value) {
        this.setCampaignValue({
          key: 'OneTimeDiscount',
          value
        })
      }
    },
    paymentMethodRequired: {
      get() {
        return this.campaign.PaymentMethodRequired
      },
      set(value) {
        this.setCampaignValue({
          key: 'PaymentMethodRequired',
          value
        })
      }
    },
    appIconId: {
      get() {
        return this.campaign.AppIconId
      },
      set(value) {
        this.setCampaignValue({
          key: 'AppIconId',
          value: value.Id
        })
      }
    },
    isPublicRegistrationLinkEnabled: {
      get() {
        return this.campaign.IsPublicRegistrationLinkEnabled
      },
      set(value) {
        this.setCampaignValue({
          key: 'IsPublicRegistrationLinkEnabled',
          value
        })
      }
    },
    activateExtraDiscountCampaign: {
      get() {
        return this.campaign.ActivateExtraDiscountCampaign
      },
      set(value) {
        this.setCampaignValue({
          key: 'ActivateExtraDiscountCampaign',
          value
        })
      }
    },
    extraDiscountCampaignId: {
      get() {
        return this.campaign.ExtraDiscountCampaignId
      },
      set(value) {
        this.setCampaignValue({
          key: 'ExtraDiscountCampaignId',
          value
        })
      }
    },
    extraDiscountCampaignActivationDelayInDays: {
      get() {
        return this.campaign.ExtraDiscountCampaignActivationDelayInDays || 0
      },
      set(value) {
        this.setCampaignValue({
          key: 'ExtraDiscountCampaignActivationDelayInDays',
          value
        })
      }
    },
    extraDiscountCampaignNumberOfDaysValid: {
      get() {
        return this.campaign.ExtraDiscountCampaignNumberOfDaysValid || 0
      },
      set(value) {
        this.setCampaignValue({
          key: 'ExtraDiscountCampaignNumberOfDaysValid',
          value
        })
      }
    },
    selectedLanguage: {
      get() {
        return this.$store.state.campaigns.selectedLanguage
      },
      set(value) {
        this.$store.commit('campaigns/setSelectedLanguage', value)
      }
    }
    // currentTranslationText: {
    //   get() {
    //     console.log(this.translations.EST)
    //     return this.translations[this.selectedLanguage]
    //   },
    //   set(value) {
    //     this.translations[this.selectedLanguage] = value
    //   }
    // }
  },
  watch: {
    currentCampaignId(newValue) {
      if (!newValue) return
      //   if (newValue !== null && newValue > 0) {
      //     this.getCampaign(this.currentCampaignId)
      //   }
      if (this.validInType === 'PLACES') {
        this.getUserPlaces({ region: this.region })
      } else if (this.validInType === 'ZONES') {
        this.getUserZones({ region: this.region })
      }
      this.getAvailableApplications()
    },
    formValid() {
      this.$emit(this.formValid ? 'valid' : 'invalid')
    },
    registrants() {
      for (let i = 0; i < this.registrants.length; i += 1) {
        if (
          this.registrants[i].Status === 'APPROVED' ||
          this.registrants[i].Status === 'PENDING'
        ) {
          this.approvedOrPendingCount += 1
        }
      }
    }
  },
  beforeDestroy() {
    this.$store.commit('campaigns/setCampaign', new Campaign().getObject())
    this.$store.commit('campaigns/setIsNew', false)
    this.$store.commit('campaigns/setIsTemplate', false)
  },
  async created() {
    if (this.campaignId && this.campaignId > 0 && !this.campaign) {
      await this.getCampaign(this.campaignId)
    }
    if (this.campaign.ID > 0) {
      await this.getRegistrants(this.campaign.ID)
    }
    if (this.isGlobalAdmin) {
      this.discountTypes.push('PREPAID_CREDIT')
    }

    await this.getUserRegions()

    if (this.validInType === '') {
      this.validInType = 'PLACES'
    }

    if (this.validInType === 'PLACES') {
      this.getUserPlaces({ region: this.region })
    } else if (this.validInType === 'ZONES') {
      this.getUserZones({ region: this.region })
    }

    if (this.userRegions.length === 1) {
      // eslint-disable-next-line prefer-destructuring
      this.region = this.userRegions[0]
      this.showUserRegionsSelect = false
    } else if (this.userRegions.length > 1) {
      this.showUserRegionsSelect = true
    }

    await this.getAvailableApplications()

    if (this.availableApplications.length) {
      // eslint-disable-next-line prefer-destructuring
      this.appId = this.availableApplications[0].ID
      if (this.availableApplications.length === 1) {
        this.showApplicationSelect = false
      } else if (this.availableApplications.length > 1) {
        this.showApplicationSelect = true
      }
    }

    if (this.isGlobalAdmin && !this.appIcons.length) {
      await this.getAppIcons()
    }

    this.localLoading = false
  },
  methods: {
    ...mapActions('app', ['getAvailableApplications', 'getAppIcons']),
    ...mapActions('users', [
      'getUserRegions',
      'getUserPlaces',
      'getUserZones',
      'getUsers'
    ]),
    ...mapActions('campaigns', [
      'getCampaigns',
      'getCampaign',
      'getRegistrants'
    ]),
    ...mapMutations('campaigns', ['setCampaignValue']),
    getAppNameByAppId(id) {
      const appInAvailableApplications = this.availableApplications.find(
        app => {
          return app.ID === id
        }
      )
      return appInAvailableApplications
        ? appInAvailableApplications.ShortName
        : 'Barking'
    },
    getAllCampaigns() {
      if (!this.campaigns.length) {
        this.getCampaigns()
      }
    },
    fetchTranslations() {
      const textCode = `${'campaign'}${this.campaign.ID}_thank_you_note`
      this.$store
        .dispatch('campaigns/getTranslation', {
          language: this.selectedLanguage,
          textCode
        })
        .then(translation => {
          this.$store.commit('campaigns/setTranslationValue', {
            key: this.selectedLanguage,
            value: translation
          })
          // this.translations[this.selectedLanguage] = translation
        })
    },
    selectedLanguageChanged() {
      if (!this.translations[this.selectedLanguage]) {
        this.fetchTranslations()
      }
    },
    currentTranslationText() {
      return this.translations[this.selectedLanguage]
    },
    textChanged(val) {
      this.translations[this.selectedLanguage] = val
    }
  }
}
</script>
<style>
::v-deep .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 0px !important;
}
.highlight:hover {
  background: lightgray !important;
}
</style>
